// import { DebugModeComp } from "../hooks/debugSetup/debugToggler";
// import { AppLogo, BadgeOutline } from "./appLogo";
// import { NameLogo } from "../assets/logo/mayowa_logo"

function PageNotFound() {
	return (
		<div className="page-not-found">
			<h3>Oopsy!</h3>
			<h4>Page not found.</h4>
			{/* <div className="container">
				<DebugModeComp />
			</div> */}
			{/* <div className="">
				<NameLogo />
			</div> */}
		</div>
	)
}
export { PageNotFound }